/*
  AUTHOR - KHYATI RADADIYA
  COMPANY NAME - RADIX ANALYTICS
  Version - 1
  Change log
    ------------------------------------------------------------
    Date         Author   Comment
    ------------------------------------------------------------
    2023-11-27	  Khyati   This is app/main/root page of project
*/

import React from "react";

import RoutesList from "./routing/PublicRouting";
import { ShowConfirmationProvider } from "./components/commonComponents/ConfirmationDialog";

import "./App.css";

function App() {
  return (
    <ShowConfirmationProvider>
      <RoutesList />
    </ShowConfirmationProvider>
  );
}

export default App;
